import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { EnfafModalComponent } from '../../enfaf-modal/enfaf-modal.component';

@Component({
  selector: 'app-modal-course-document-blocked',
  standalone: true,
  imports: [EnfafModalComponent, TranslatePipe],
  templateUrl: './modal-course-document-blocked.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ModalCourseDocumentBlockedComponent {
  private readonly dialogRef = inject(MatDialogRef<ModalCourseDocumentBlockedComponent>);
  private readonly router = inject(Router);

  goToProfile(): void {
    this.dialogRef.close();
    void this.router.navigate(['/student/profile']);
  }
}
